import React from 'react';
import "./CompanyIntroHome.css"
import PieChart from "./components/PieChart"
import SimplePieChart from "./components/SimplePieChart"
import StackBarChart from "./components/StackBarChart"
import Portait from './components/Portait';
import { useHistory } from "react-router-dom";
import { observer } from "mobx-react-lite";
import home_btn from "../../img/CompanyIntroHomeImg/home-btn.png";
import market_btn from "../../img/CompanyIntroHomeImg/market-btn.png";
import com_logo from "../../img/CompanyIntroHomeImg/com-logo.png";
import home_icon from "../../img/CompanyIntroHomeImg/home-icon.png";
import upgrade_icon from "../../img/CompanyIntroHomeImg/upgrade-icon.png";
import map from "../../img/CompanyIntroHomeImg/map.png";
import triangle from "../../img/CompanyIntroHomeImg/triangle.png";
import home_back from "../../img/CompanyIntroHomeImg/home-back.jpg";
import ceo_portrait from "../../img/CompanyIntroHomeImg/ceo-portrait.png";
import cmo_portrait from "../../img/CompanyIntroHomeImg/cmo-portrait.png";
import cfo_portrait from "../../img/CompanyIntroHomeImg/cfo-portrait.png";
import cio_portrait from "../../img/CompanyIntroHomeImg/cio-portrait.png";
import cto_portrait from "../../img/CompanyIntroHomeImg/cto-portrait.png";
import ceo2_portrait from "../../img/CompanyIntroHomeImg/ceo2-portrait.png";
import belongings from "../../img/CompanyIntroHomeImg/belongings_img.svg";
import finance from "../../img/CompanyIntroHomeImg/finance_img.svg";
import product from "../../img/CompanyIntroHomeImg/product_img.svg";
import sales from "../../img/CompanyIntroHomeImg/sales_img.svg";
// import remarkGfm from 'https://esm.sh/remark-gfm@3'
import remarkGfm from 'remark-gfm'
import ReactDom from 'react-dom'
import ReactMarkdown from 'react-markdown'


// "/src/img/CompanyIntroHomeImg/"

function Home() {
    let history = useHistory();

    const markdown = `(markdown example) Just a link: https://reactjs.com.`

    return (
        <div className="home-page">
            <div className="nav-block">
                <div className="nav-btn">
                    <div className="item" onClick={() => { history.push("/") }}> {/*history.push(path)將網頁轉址到path*/}
                        <img src={home_btn} alt="home-btn" />   {/*左邊首頁+市場的buttton */}
                        <div className="text" >首頁</div>
                    </div>
                    <div className="item" onClick={() => { history.push("/market") }}>
                        <img src={market_btn} alt="market-btn" />
                        <div className="text">市場</div>
                    </div>
                    <div className="item">
                        <img src={product} alt="product-btn" />
                        <div className="text">產品</div>
                    </div>
                    <div className="item">
                        <img src={sales} alt="sales-btn" />
                        <div className="text">銷售</div>
                    </div>
                    <div className="item">
                        <img src={belongings} alt="belongings-btn" />
                        <div className="text">所有權</div>
                    </div>
                    <div className="item">
                        <img src={finance} alt="finance-btn" />
                        <div className="text">財務</div>
                    </div>
                </div>
            </div>
            <div className="main-block">
                <div style={{ marginTop: "38px", marginBottom: "28px", textAlign: "center" }}>
                    <div className="back-btn" onClick={() => { history.push("./CompanyIntroNew") }}>編輯網頁首頁</div>
                </div>
                <div className="row">   {/*這個row包含了以下三個col*/}
                    <div className="col">
                        <div className="card small-card">
                            <div className="title">problem</div>
                            <div className="content">text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card small-card">
                            <div className="title">solution</div>
                            <div className="content">text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text  </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card small-card">
                            <div className="title">Why now?</div>
                            <div className="content">text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div className="card" style={{ flexDirection: "row" }}>
                            <img src={com_logo} height={94} width={94} alt="com-logo" />
                            <div className="com-desc-block">
                                <div className="row">
                                    <span className="com-name">公司名稱</span>
                                    <div className="com-name-block">綠能科技</div>
                                    <span className="slogan">一句話動人心弦，且簡單描述你們公司的話。</span>
                                </div>
                                <div>
                                    <div className="content">text text text text text text text text text  text text text text  text text text text  text text text text  text text text text  text text text text  text text text text  text text text text  text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text </div>
                                </div>
                            </div>
                            {/* <div className="invest-btn-container">
                                <div className="invest-btn" onClick={() => { alert("我要注資") }}>我要注資</div>
    </div>*/}
                        </div>
                    </div>
                </div>
                <div className="row" style={{ marginTop: "30px" }}>
                    <div className="col">
                        <video width={"100%"} controls>
                            <source src="https://www.datocms-assets.com/22581/1603987530-1-pixabay.mp4" />  {/*src部分應該是要放入前面上傳的video檔?*/}
                        </video>
                    </div>
                    <div className="col">
                        <div className="icon-card card" style={{ marginBottom: "20px" }}>
                            <div className="icon">
                                <div className={"title"}>產品服務特點</div>
                                <img src={home_icon} width={50} alt="" />
                            </div>
                            <div className="text">text text text text texttext text text text texttext text text text texttext text text text texttext text text text texttext text text text texttext text text text texttext text text text text</div>
                        </div>
                        <div className="icon-card card">
                            <div className="icon">
                                <div className="title">產品服務優勢</div>
                                <img src={upgrade_icon} width={50} alt="" />
                            </div>
                            <div className="text">text text text text texttext text text text texttext text text text texttext text text text texttext text text text texttext text text text texttext text text text texttext text text text text</div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div className="icon-card card">
                            <div className="icon">
                                <img src={map} width={440} alt="" />
                                <span className="market-distribution">市場分佈</span>
                            </div>
                            <div className="chart-block">
                                <div className="item">
                                    <div className="chart">
                                        <ReactMarkdown children={markdown} remarkPlugins={[remarkGfm]} />
                                    </div>
                                    {/* <div className="chart-text">
                                        text text text text text text text text text text text text text text text
                                        text text text text text text text text text text text text text text text
                                    </div> */}
                                </div>
                                <div className="item">
                                    <div className="chart">
                                        <ReactMarkdown children={markdown} remarkPlugins={[remarkGfm]} />
                                    </div>
                                    {/* <div className="chart-text">
                                        text text text text text text text text text text text text text text text
                                        text text text text text text text text text text text text text text text
                                    </div> */}
                                </div>
                                <div className="item">
                                    <div className="chart">
                                        <ReactMarkdown children={markdown} remarkPlugins={[remarkGfm]} />
                                    </div>
                                    {/* <div className="chart-text">
                                        text text text text text text text text text text text text text text text
                                        text text text text text text text text text text text text text text text
                                    </div> */}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div className="row">
                            <div className="col" style={{ marginLeft: 0 }}>
                                <div className="card" >
                                    <div className="competition-block">
                                        <div className="competition-title">首要競爭者</div>
                                        <div className="competition-subtitle">
                                            <div className="competition-com-name">Company1</div>
                                            <div className="competition-analyze">analyze your competitors</div>
                                        </div>
                                        <div className="chart">
                                            <SimplePieChart />
                                        </div>
                                        <div className="competition-desc">analyze your text analyze your text analyze your text analyze your text analyze your text analyze your text analyze your text analyze your text analyze your text analyze your text</div>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card">
                                    <div className="competition-block">
                                        <div className="competition-title">次要競爭者</div>
                                        <div className="competition-subtitle">
                                            <div className="competition-com-name">Company2</div>
                                            <div className="competition-analyze">analyze your competitors</div>
                                        </div>
                                        <div className="chart">
                                            <SimplePieChart />
                                        </div>
                                        <div className="competition-desc">analyze your text analyze your text analyze your text analyze your text analyze your text analyze your text analyze your text analyze your text analyze your text analyze your text</div>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card">
                                    <div className="competition-block">
                                        <div className="competition-title">第三競爭者</div>
                                        <div className="competition-subtitle">
                                            <div className="competition-com-name">Company3</div>
                                            <div className="competition-analyze">analyze your competitors</div>
                                        </div>
                                        <div className="chart">
                                            <SimplePieChart />
                                        </div>
                                        <div className="competition-desc">analyze your text analyze your text analyze your text analyze your text analyze your text analyze your text analyze your text analyze your text analyze your text analyze your text</div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="row">
                            <div className="col" style={{ marginLeft: 0 }}>
                                <div className="card">
                                    <div className="row">
                                        <div className="col">
                                            <div className="title">財務報表</div>
                                            <div className="content">text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text </div>
                                        </div>
                                        <div className="col financial-block">
                                            <div>
                                                <span className="financial-title">Financial statement</span>
                                                <span className="financial-number">-128</span>
                                            </div>
                                            <div className="financial-subtitle">📉 from Y1 to Y3</div>

                                            <StackBarChart />
                                        </div>
                                        <div className="col financial-block">
                                            <div>
                                                <span className="financial-title">Financial statement</span>
                                                <span className="financial-number">-128</span>
                                            </div>
                                            <div className="financial-subtitle" >📉 from Y1 to Y3</div>
                                            <StackBarChart />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="card business-model">
                        <img src={triangle} alt="" />
                        <span className="business-title">商業模式</span>
                        <span className="business-text">text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text </span>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div className="card" style={{ flexDirection: "row" }}>
                            <div className="team-intro">團隊介紹</div>
                            <div className="col">
                                <div className="row">
                                    <Portait imgUrl={ceo_portrait} text="CEO" />
                                    <Portait imgUrl={cmo_portrait} text="CMO" />
                                    <Portait imgUrl={cfo_portrait} text="CFO" />
                                    <Portait imgUrl={cio_portrait} text="CIO" />
                                    <Portait imgUrl={cto_portrait} text="CTO" />
                                    <Portait imgUrl={ceo2_portrait} text="CEO" />
                                </div>
                            </div>
                            <div className="col">
                                <div className="row">
                                    <div className="team-text">
                                        text text text text text text text text text text text text text text text text text text text text text text text
                                        text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};



export default observer(Home);